<template>
  <v-modal :modal-id="'regionSelector'"
           :modal-class="'region-selector'"
           :title-id="'regionTitle'"
           @close="close()">
    <span v-html="title"/>
    <span v-html="content"/>
  </v-modal>
</template>

<script>
import axios from 'axios'
import xcHelperMixin from '../mixins/xc-helper'
import VModal from './modals/Modal'

export default {
  name: 'XcRegionSelector',
  components: { VModal },
  mixins: [xcHelperMixin],
  data () {
    return {
      title: null,
      content: null
    }
  },
  created: async function () {
    await this.getSelector()

    this.regionSelectListener()
  },
  methods: {
    getSelector: async function () {
      await axios.get('/selector')
        .then((response) => {
          const selector = document.createElement('div')
          selector.innerHTML = response.data

          this.title = selector.querySelector('h2#regionTitle').outerHTML
          this.content = selector.querySelector('div.available-regions').outerHTML
        })
    },
    close: function () {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/XcRegionSelector.vue